import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const Grid = ({ color, width, height, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={width || '22px'}
      height={height || '22px'}
      color={color || 'currentColor'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 22 22"
      fill="none"
    >
      <rect x="3.5" y="3.5" width="3" height="3" stroke={color || 'currentColor'} strokeWidth="1" />
      <rect x="3.5" y="9.5" width="3" height="3" stroke={color || 'currentColor'} strokeWidth="1" />
      <rect
        x="3.5"
        y="15.5"
        width="3"
        height="3"
        stroke={color || 'currentColor'}
        strokeWidth="1"
      />
      <rect x="9.5" y="3.5" width="3" height="3" stroke={color || 'currentColor'} strokeWidth="1" />
      <rect x="9.5" y="9.5" width="3" height="3" stroke={color || 'currentColor'} strokeWidth="1" />
      <rect
        x="9.5"
        y="15.5"
        width="3"
        height="3"
        stroke={color || 'currentColor'}
        strokeWidth="1"
      />
      <rect
        x="15.5"
        y="3.5"
        width="3"
        height="3"
        stroke={color || 'currentColor'}
        strokeWidth="1"
      />
      <rect
        x="15.5"
        y="9.5"
        width="3"
        height="3"
        stroke={color || 'currentColor'}
        strokeWidth="1"
      />
      <rect
        x="15.5"
        y="15.5"
        width="3"
        height="3"
        stroke={color || 'currentColor'}
        strokeWidth="1"
      />
    </StyledSvg>
  );
};
